/**
 * @module Execusion/Orderbook
 * @desc Maintained by: Moloud. Broken by: We'll find out in Git history.
 */

import MarketMakingOrderBookPanel from "src/Components/MarketMakingOrderBookPanel";
import { useAppSelector } from "src/App/hooks";
import useOrderBookPolling from "./useOrderBookPolling";
import { getOrderBookDepth, getOrderBookDetails } from "src/Requests/automaticMarketMaking";
import useLiveOrderBooks from "src/Hooks/useLiveOrderBooks";

const Orderbook = () => {
  const taskId = useAppSelector(
    (store) => store.automaticMarketMaking.taskRow?.id
  );

  const depthRequest = useOrderBookPolling(taskId, getOrderBookDepth);
  const orderBookRequest = useOrderBookPolling(taskId, getOrderBookDetails);
  const liveOrderBooks = useLiveOrderBooks({
    enabled: true,
    includeOwnOrders: true,
    automaticMarketMakingTaskId: taskId,
  });

  return <MarketMakingOrderBookPanel
    orderBook={liveOrderBooks.resolveOrderBook(depthRequest.response?.fullOrderBook)}
    openOrders={liveOrderBooks.ownOrders || depthRequest.response?.openOrders}
    details={orderBookRequest.response}
  />;
};

export default Orderbook;
